import React from 'react';

import { Banner, Hero } from './components';
import { BannerType, HeroType } from './bannerConfigAggregator';

export type PageBuilderBannerProps = BannerType | HeroType;

/**
 * Return the PB Banner
 * @param props
 * @constructor
 */
export function PageBuilderBanner(props: PageBuilderBannerProps) {

    /**
     * Render the banner Block as a Hero or a standard Banner
     */
    switch (props.appearance) {
        case 'hero':
            return <Hero {...(props as HeroType)} />;
        default:
            return <Banner {...(props as BannerType)} />;
    }
}
